import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';
import { storage } from '@/utils/storage';
import {projectName} from "@/utils/config";

export default [
  {
    path: '/IFPageOneHFiftyThreePreLogin',
    name: 'IFPageOneHFiftyThreePreLogin',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHFiftyThree/preLogin.vue'),
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      /* 20230727 返回拦截下载页 */
      if (
        from.path === '/IFPageOneHFiftyThreeLogin' ||
        from.path === '/IFPageOneHFiftyThreeLoginSecond'
      ) {
        window.history.back();
      } else {
        next();
      }
    },
  },
  {
    path: '/IFPageOneHFiftyThreeLogin',
    name: 'pageOneHFiftyThreeLogin',
    meta: {
      title: '我的额度',
    },
    component: () => import('@/pages/pageListAll/pageOneHFiftyThree/login.vue'),
  },
  {
    path: '/IFPageOneHFiftyThreeLoginLoading',
    name: 'pageOneHFiftyThreeLoginLoading',
    meta: {
      title: '我的额度',
    },
    component: () => import('@/pages/pageListAll/pageOneHFiftyThree/loginLoading.vue'),
  },
  {
    path: '/IFPageOneHFiftyThreeLeaveInfo',
    name: 'pageOneHFiftyThreeLeaveInfo',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHFiftyThree/leaveInfo.vue'),
  },
  {
    path: '/IFPageOneHFiftyThreeResult',
    name: 'pageOneHFiftyThreeResult',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHFiftyThree/result.vue'),
  },
  {
    path: '/IFPageOneHFiftyThreeLoading',
    name: 'pageOneHFiftyThreeLoading',
    component: () => import('@/pages/pageListAll/pageOneHFiftyThree/loading.vue'),
    meta: {
      title: '额度检测',
    },
  },
  {
    path: '/IFPageOneHFiftyThreeLoginSecond',
    name: 'pageOneHFiftyThreeLoginSecond',
    component: () => import('@/pages/pageListAll/pageOneHFiftyThree/loginSecond.vue'),
    meta: {
      title: projectName,
    },
  },
  {
    path: '/IFPageOneHFiftyThreeOnline',
    name: 'pageOneHFiftyThreeOnline',
    component: () => import('@/pages/pageListAll/pageOneHFiftyThree/online.vue'),
    meta: {
      title: projectName,
    },
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      /* 网贷来源页 */
      if (from.path == '/IFPageOneHFiftyThreeLoginSecond') {
        storage.setItem('onlineGoApply', null);
      } else {
        to.query.time = `${new Date().getTime()}`;
      }
      next();
    },
  },
  {
    path: '/IFPageOneHFiftyThreeGuide',
    name: 'pageOneHFiftyThreeLoginGuide',
    component: () => import('@/pages/pageListAll/pageOneHFiftyThree/guide.vue'),
    meta: {
      title: projectName,
    },
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      to.query.formUrl = from.path;
      next();
    },
  },
  {
    path: '/IFPageOneHFiftyThreeCar',
    name: 'pageOneHFiftyThreeCar',
    component: () => import('@/pages/pageListAll/pageOneHFiftyThree/car.vue'),
    meta: {
      title: '补充留资',
    },
  },
  {
    path: '/IFPageOneHFiftyThreeCarDetails',
    name: 'pageOneHFiftyThreeCarDetails',
    component: () => import('@/pages/pageListAll/pageOneHFiftyThree/carDetails.vue'),
    meta: {
      title: '申请结果',
    },
  },
  {
    path: '/IFPageOneHFiftyThreeBlank',
    name: 'pageOneHFiftyThreeBlank',
    component: () => import('@/pages/pageListAll/pageOneHFiftyThree/blank.vue'),
    meta: {
      title: projectName,
    },
  },
  {
    path: '/IFPageOneHFiftyThreeOnlineTab',
    name: 'pageOneHFiftyThreeOnlineTab',
    component: () => import('@/pages/pageListAll/pageOneHFiftyThree/onlineTab.vue'),
    meta: {
      title: projectName,
    },
  },
  {
    path: '/IFPageOneHFiftyThreeOnlineAd',
    name: 'pageOneHFiftyThreeOnlineAd',
    component: () => import('@/pages/pageListAll/pageOneHFiftyThree/onlineAd.vue'),
    meta: {
      title: projectName,
    },
  },
];
